import { ACL } from '@agyletime/vue-3-common/src/typings/acl';
import { OperationsAdminRequiredRole } from '@/pages/OperationsAdministration/utils/navigation';

export function isOperationsAdministrationEnabled(acl: ACL['acl']) {
    return acl(OperationsAdminRequiredRole);
}
